const Er = () => {
    return ( 
        <div className='loading'>
            <h1>Error!</h1>        
        </div>
    )
}

export default Er;